import { render, staticRenderFns } from "./SGPFormHoraComponent.vue?vue&type=template&id=33463909&scoped=true"
import script from "./SGPFormHoraComponent.vue?vue&type=script&lang=js"
export * from "./SGPFormHoraComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPFormHoraComponent.vue?vue&type=style&index=0&id=33463909&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33463909",
  null
  
)

export default component.exports